import React, { useEffect, useState } from 'react';

/**
 * ProgressRing Component for Dettio
 * @param {number} percent - The percentage of debt free (0-100)
 * @param {number} size - The diameter of the ring in pixels
 */
const ProgressRing = ({ percent = 0, size = 160 }) => {
  const [offset, setOffset] = useState(0);
  const [isUpdating, setIsUpdating] = useState(false);
  const radius = (size / 2) - 10; // Padding for the stroke width
  const circumference = 2 * Math.PI * radius;

  useEffect(() => {
    // Trigger pulse animation when percent changes
    if (percent > 0) {
      setIsUpdating(true);
      setTimeout(() => setIsUpdating(false), 3000); // 3 pulses (1s each)
    }
    
    // Small delay to ensure the entry animation triggers after mount
    const progressOffset = circumference - (percent / 100) * circumference;
    const timer = setTimeout(() => setOffset(progressOffset), 100);
    return () => clearTimeout(timer);
  }, [percent, circumference]);

  return (
    <div 
      className={`ring-container ${isUpdating ? 'updating' : ''}`} 
      style={{ 
        position: 'relative', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        width: size,
        height: size
      }}
    >
      <svg width={size} height={size}>
        <defs>
          <linearGradient id="ring-gradient" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#00FFCC" />
            <stop offset="100%" stopColor="#3399FF" />
          </linearGradient>
        </defs>
        
        {/* Background Track */}
        <circle
          className="ring-track"
          cx={size / 2}
          cy={size / 2}
          r={radius}
          strokeWidth="10"
        />
        
        {/* Animated Progress Fill */}
        <circle
          className="ring-fill"
          cx={size / 2}
          cy={size / 2}
          r={radius}
          strokeWidth="10"
          strokeDasharray={circumference}
          style={{ 
            strokeDashoffset: offset,
            stroke: "url(#ring-gradient)",
            fill: "transparent",
            strokeLinecap: "round",
            transition: "stroke-dashoffset 1.5s cubic-bezier(0.4, 0, 0.2, 1)",
            transform: "rotate(-90deg)",
            transformOrigin: "50% 50%"
          }}
        />
      </svg>

      {/* Center Text Label */}
      <div 
        className="ring-label" 
        style={{ 
          position: 'absolute', 
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <span className="stat-value teal" style={{ 
          fontSize: '2.2rem', 
          fontWeight: '800',
          lineHeight: '1'
        }}>
          {percent}%
        </span>
        <span style={{ 
          fontSize: '0.65rem', 
          opacity: 0.7, 
          letterSpacing: '1.5px', 
          fontWeight: '700',
          marginTop: '4px',
          color: '#fff'
        }}>
          DEBT FREE
        </span>
      </div>
    </div>
  );
};

export default ProgressRing;
